import { CoursesExceedingHoursFilterDatamodel } from '../side-bar-filter/courses-exceeding-hours-filter-datamodel';
import { toast } from 'react-toastify';
import appApi from '../../../../../api/app-api';
import { CourseHoursExceedingReport } from '../../../../../api/types/reports/finanace/course-hours-excess-report';
import { displayErrorText } from '../../../../../api/errors/api-error-codes';

export const fetchCourseExceedingHourOperations = async (
  filters: CoursesExceedingHoursFilterDatamodel,
  setLoading: (loading: boolean) => void,
  setData: (data: CourseHoursExceedingReport[]) => void,
) => {
  try {
    setLoading(true);
    if (!filters.exceedingHours) {
      toast.error('הזן בבקשה מספר שעות חריגה מינימלי...');
    } else {
      const res = await appApi.getCourseExceedingHours(filters);
      if (res.data.errCode) {
        toast.warn(displayErrorText(res.data.errCode));
        setLoading(false);
        return;
      }
      setData(res.data.body);
    }
  } catch (error) {
    console.error(
      `fetchCourseExceedingHourOperations is failed with the filters: ${JSON.stringify(filters)} and the error: ${error}`,
    );
    toast.error('משהו קרה, יש לנסות שוב בעוד מספר רגעים...');
  } finally {
    setLoading(false);
  }
};
